import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";


export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={`/${window.location.search}`} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden flex-col overflow-hidden bg-[#F0FEFF] lg:flex">
        <div className="relative z-10 p-12 text-[#0A3967]">
          <div className="flex items-center gap-3">
            <img data-testid="login-logo" src="/pln-logo.png" alt="PLN Electricity Services" className="h-10 w-auto" />
            <span className="font-heading text-lg font-bold">Kinerja Distribusi</span>
          </div>
          <div className="mt-12 max-w-lg">
            <h1 className="font-heading text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight">Pantau capaian setiap unit, dalam satu layar.</h1>
            <p className="mt-4 text-slate-600">Pendapatan, SLA, BPP, RPT-RCT, Denda, Reward hingga produktivitas petugas — tersinkron dari Google Sheets setiap hari.</p>
          </div>
        </div>
        <img data-testid="login-hero-image" src="/login-hero.png" alt="Ilustrasi jaringan distribusi listrik PLN" className="mt-auto max-h-[58vh] w-full object-cover object-bottom [mask-image:linear-gradient(to_bottom,transparent,black_18%)]" />
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="rise w-full max-w-sm space-y-6">
          <div>
            <img src="/pln-logo.png" alt="PLN Electricity Services" className="mb-6 h-9 w-auto lg:hidden" />
            <h2 className="font-heading text-3xl font-bold tracking-tight">Masuk</h2>
            <p className="mt-1 text-sm text-muted-foreground">Gunakan akun yang diberikan administrator.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="username">Username</Label>
            <Input id="username" data-testid="login-username-input" type="text" autoComplete="username" autoCapitalize="none" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Kata sandi</Label>
            <Input id="password" data-testid="login-password-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p data-testid="login-error" className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
          <Button data-testid="login-submit-button" type="submit" className="w-full" disabled={busy}>
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Masuk
          </Button>
        </form>
      </div>
    </div>
  );
}
